import {
  ComponentAccordion,
  isComponentAccordion,
} from "types/CMS/KontentAI/content-types/accordion";
import {
  ComponentColumnCardGroup,
  isComponentColumnCardGroup,
} from "types/CMS/KontentAI/content-types/column_card_group";
import {
  ComponentFeature,
  isComponentFeature,
} from "types/CMS/KontentAI/content-types/feature";
import {
  ComponentInfoCardGroup,
  isComponentInfoCardGroup,
} from "types/CMS/KontentAI/content-types/info_card_group";

import { infoCardGroupResolver } from "./infoCardGroup";
import { featureResolver } from "./feature";
import { columnCardGroupResolver } from "./columnCardGroup";
import { accordionResolver } from "./accordion";
import {
  generalSections,
  section,
} from "types/CMS/Unum/GeneralPage/generalSection";
import { createResolver } from "./Factories/ResolverFactory";
import { productTaxonomyFilter } from "./Filters/productTaxomanyFilter";

export const generalSectionResolver = createResolver({
  resolve: (
    sections: (
      | ComponentAccordion
      | ComponentColumnCardGroup
      | ComponentFeature
      | ComponentInfoCardGroup
    )[],
    filters
  ): generalSections => {
    return {
      type: "generalSections",
      sections: sections
        .map((section): section | undefined => {
          if (isComponentAccordion(section)) {
            return accordionResolver
              .resolve(section)
              .filter((resolved) =>
                productTaxonomyFilter(resolved, filters?.usersProducts)
              ).result;
          }
          if (isComponentColumnCardGroup(section)) {
            return columnCardGroupResolver
              .resolve(section)
              .filter((resolved) =>
                productTaxonomyFilter(resolved, filters?.usersProducts)
              ).result;
          }
          if (isComponentFeature(section)) {
            return featureResolver
              .resolve(section)
              .filter((resolved) =>
                productTaxonomyFilter(resolved, filters?.usersProducts)
              ).result;
          }
          if (isComponentInfoCardGroup(section)) {
            return infoCardGroupResolver
              .resolve(section)
              .filter((resolved) =>
                productTaxonomyFilter(resolved, filters?.usersProducts)
              ).result;
          }
          return undefined;
        })
        .filter((item): item is section => item !== undefined),
    };
  },
});
